module.exports = __webpack_public_path__ + "media/images/3dViewGray-aabbfb00c4672b3dc145e3d8b3ab3f2b.svg";